import circleCross from './circleCross'
import circleTick from './circleTick'
import pdfFile from './pdfFile'
import download from './download'
import csvFile from './csvFile'

const Icons = {
  circleCross,
  circleTick,
  pdfFile,
  download,
  csvFile
}
export default Icons